import { Link } from 'react-router-dom';
import { Divider } from '@mantine/core';
// utils
import { cn } from '@/utils';

interface GroupNavigationProps {
    baseUrl: string;
    groups: string[];
    selectedGroup?: string;
    withAll?: boolean;
    withUnassigned?: boolean;
}

const GroupNavigation = ({
    baseUrl,
    groups,
    selectedGroup,
    withAll,
    withUnassigned
}: GroupNavigationProps) => {
    const groupClassName =
        'block border-l border-gray-4 text-sm py-2.5 text-black no-underline px-4 hover:bg-blue-100 hover:bg-opacity-50';
    const activeClassName = 'bg-blue-0 border-blue-4';
    return (
        <div>
            <Link
                className={cn(groupClassName, {
                    invisible: !withAll,
                    [activeClassName]: !selectedGroup
                })}
                to={baseUrl}
            >
                All
            </Link>
            {groups.map((group) => (
                <Link
                    className={cn(groupClassName, {
                        [activeClassName]: selectedGroup === group
                    })}
                    key={group}
                    to={`${baseUrl}/${encodeURIComponent(group)}`}
                >
                    {group}
                </Link>
            ))}

            {withUnassigned ? (
                <>
                    <Divider />
                    <Link
                        className={cn(groupClassName, {
                            [activeClassName]: selectedGroup === 'Unassigned'
                        })}
                        key="Unassigned"
                        to={`${baseUrl}/Unassigned`}
                    >
                        Unassigned
                    </Link>
                </>
            ) : undefined}
        </div>
    );
};

export default GroupNavigation;
